import { render, staticRenderFns } from "./room_inform.vue?vue&type=template&id=601a8aac&scoped=true&"
import script from "./room_inform.vue?vue&type=script&lang=js&"
export * from "./room_inform.vue?vue&type=script&lang=js&"
import style0 from "./room_inform.vue?vue&type=style&index=0&lang=less&"
import style1 from "./room_inform.vue?vue&type=style&index=1&id=601a8aac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601a8aac",
  null
  
)

export default component.exports